'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('../css/PostCodeCityStreetComponent.css');

var _AutocompleteField = require('./AutocompleteField');

var _AutocompleteField2 = _interopRequireDefault(_AutocompleteField);

var _Textfield = require('./Textfield');

var _Textfield2 = _interopRequireDefault(_Textfield);

var _MessageBox = require('./MessageBox');

var _MessageBox2 = _interopRequireDefault(_MessageBox);

var _modelsLib = require('models-lib');

var _Vas = require('../Vas');

var _Vas2 = _interopRequireDefault(_Vas);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
Pflichtproperties:
AppURL={Vas.ApplicationUrl} 
me={this} Id={"name"} ref={"name"} name="name"
IsRequired={true/false} Editable={true/false}  
Label={ Vas.Resources.Labels["Name"]} 
TitleMessageNotValidCharacter={Vas.Resources.Labels["Note"]} 
MessageNotValidCharacter={Vas.Resources.Labels["NotValidCharacter"]} 

optional:
Modus={"Name"} Tooltip={Vas.Resources.Tooltips["Name"]} OnChange={()=>{ this.setState({ Name:  $("#name").val() })}}
Autocomplete={false/true}=>"off"/"on"
*/
var PostCodeCityStreetComponent = function (_Component) {
  _inherits(PostCodeCityStreetComponent, _Component);

  function PostCodeCityStreetComponent(props) {
    _classCallCheck(this, PostCodeCityStreetComponent);

    var _this = _possibleConstructorReturn(this, (PostCodeCityStreetComponent.__proto__ || Object.getPrototypeOf(PostCodeCityStreetComponent)).call(this, props));

    _this.state = {};

    _this.PostCode = "";
    _this.City = "";
    _this.Street = "";

    _this.TimeOutTime = _this.props.TimeOutTime ? _this.props.TimeOutTime : 1000;

    _this.StreetsModel = new _modelsLib.StreetsModel([_this]);
    _this.Request = new _modelsLib.RequestAjaxClass(function (error) {
      _this.props.ErrorHandlingPage ? _this.props.ErrorHandlingPage(error) : "";
    }, null);

    _this.streetInput = _react2.default.createRef();
    _this.postCodeInput = _react2.default.createRef();
    _this.cityInput = _react2.default.createRef();

    _this.required = _this.props.Required !== undefined && _this.props.Required !== null ? _this.props.Required : true;

    _this.allFilled = _this.required === true ? false : true;
    _this.first = null;

    _this.state.editable = true;

    _this.WidthPostCodeCity = _this.props.WidthPostCodeCity ? _this.props.WidthPostCodeCity : 170;
    _this.WidthStreet = _this.props.WidthStreet ? _this.props.WidthStreet : 400;
    return _this;
  }

  _createClass(PostCodeCityStreetComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.Request.setAuth(false);
      this.Request.setApiKey(this.props.ApiKey);
      this.Request.setApiUrl(this.props.ApiUrl);

      this.StreetsModel.SetRequest(this.Request);
    }
  }, {
    key: 'Update',
    value: function Update(observer) {
      var me = this;
      this.setState({}, function () {
        if (observer === "Streets") {
          var streets = [];
          if (me.StreetsModel.Streets.length > 0) {
            streets = me.StreetsModel.Streets;
          }
          me.streetInput.current.setState({ Data: streets, Icon: '', placeholder: '' });
        }
      });
    }
  }, {
    key: 'getStreets',
    value: function getStreets() {
      var me = this;
      if (this.City.length > 0 && this.PostCode.length > 0) {
        me.streetInput.current.setState({ Icon: "Loop" });
        this.StreetsModel.GetStreets(this.City, this.PostCode);
      }
    }
  }, {
    key: 'getAllFilled',
    value: function getAllFilled() {
      if (this.required === true) {
        var i = 0;
        this.first = null;
        if (document.getElementById('Street').value.length > 0) {
          i++;
        } else {
          this.first = this.streetInput;
        }

        if (document.getElementById('place').value.length > 0) {
          i++;
        } else {
          this.first = this.cityInput;
        }

        if (document.getElementById('zip').value.length > 0) {
          i++;
        } else {
          this.first = this.postCodeInput;
        }

        if (i === 3) {
          this.allFilled = true;
        }
      }
    }
  }, {
    key: 'returnFilled',
    value: function returnFilled() {
      return [this.allFilled, this.first];
    }
  }, {
    key: 'returnFields',
    value: function returnFields() {
      return [this.postCodeInput, this.cityInput, this.streetInput];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: "Container" },
          _react2.default.createElement(
            'div',
            { className: "ContainerLeft" },
            _react2.default.createElement(_Textfield2.default, {
              Width: this.WidthPostCodeCity,
              me: this,
              Editable: this.state.editable,
              IsRequired: this.required,
              Id: "zip",
              name: 'zip',
              ref: this.postCodeInput,
              Tooltip: _Vas2.default.getText('Tooltips', "Zip"),
              Label: _Vas2.default.getText('Labels', "Zip"),
              OnBlur: function OnBlur() {
                if ((0, _jquery2.default)("#zip").val().length === 5) {
                  _this2.PostCode = (0, _jquery2.default)("#zip").val();
                } else {
                  (0, _jquery2.default)("#zip").val('');
                  _reactDom2.default.render(_react2.default.createElement(_MessageBox2.default, {
                    Message: _Vas2.default.getText('Labels', "PLZNote"),
                    Title: _Vas2.default.getText('Titles', "Note"),
                    Field: "zip" }), document.getElementById('messageContainer'));
                }
                _this2.getAllFilled();
              } })
          ),
          _react2.default.createElement(
            'div',
            { className: "ContainerRight" },
            _react2.default.createElement(_Textfield2.default, {
              Width: this.WidthPostCodeCity,
              me: this,
              Editable: this.state.editable,
              IsRequired: this.required,
              Id: "place",
              name: 'place',
              ref: this.cityInput,
              Tooltip: _Vas2.default.getText('Tooltips', "Place"),
              Label: _Vas2.default.getText('Labels', "City"),
              OnChange: function OnChange() {
                _this2.City = (0, _jquery2.default)("#place").val();
              },
              OnBlur: function OnBlur() {
                _this2.getAllFilled();_this2.getStreets();
              } })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: "Container" },
          _react2.default.createElement(
            'div',
            { className: "ContainerLeft" },
            _react2.default.createElement(_AutocompleteField2.default, {
              AppURL: _Vas2.default.ApplicationUrl,
              TitleMessageFalseStreet: _Vas2.default.getText('ErrorMessages', "Error"),
              MessageFalseStreet: _Vas2.default.getText('ErrorMessages', "FalseStreet"),
              Modus: "Street",
              ref: this.streetInput,
              Id: "Street",
              Float: 'left',
              IsRequired: this.required,
              editable: this.state.editable,
              Label: _Vas2.default.getText('Labels', "Street"),
              Data: this.state.streets,
              OnBlur: function OnBlur() {
                _this2.Street = (0, _jquery2.default)("#Street").val();_this2.getAllFilled();
              },
              Tooltip: _Vas2.default.getText('Tooltips', "Street"),
              TimeOutTime: this.TimeOutTime,
              Width: this.WidthStreet })
          )
        )
      );
    }
  }]);

  return PostCodeCityStreetComponent;
}(_react.Component);

exports.default = PostCodeCityStreetComponent;